'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.urlRegex = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.linkifyUrls = linkifyUrls;
exports.addEmojis = addEmojis;
exports.linkifyChannels = linkifyChannels;
exports.linkifyUsers = linkifyUsers;
exports.createNickColour = createNickColour;
exports.hexVal = hexVal;
exports.mapRange = mapRange;
exports.formatAndT = formatAndT;
exports.formatUser = formatUser;
exports.formatUserFull = formatUserFull;
exports.formatText = formatText;
exports.enrichText = enrichText;
exports.styleBlocksToHtml = styleBlocksToHtml;
exports.formatDuration = formatDuration;
exports.formatNumber = formatNumber;
exports.t = t;

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _ThemeManager = require('@/libs/ThemeManager');

var _ThemeManager2 = _interopRequireDefault(_ThemeManager);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _ipRegex = require('ip-regex');

var ipRegex = _interopRequireWildcard(_ipRegex);

var _Colours = require('./Colours');

var Colours = _interopRequireWildcard(_Colours);

var _Md = require('./Md5');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var urlRegex = exports.urlRegex = new RegExp(/(([A-Za-z][A-Za-z0-9-]*:\/\/)|(www\.))/.source + '(' + /([\w\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF.-]+\.[a-zA-Z]{2,63})/.source + '|' + ipRegex.v4().source + '|' + '(\\[?' + ipRegex.v6().source + '\\]?)' + ')' + /(:[0-9]+)?/.source + /(\/[\w\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF!:.?$'()[\]*,;~+=&%@!\-/]*)?/.source + /(#.*)?/.source, 'i');

function linkifyUrls(input, _opts) {
    var opts = _opts || {};
    var foundUrls = [];
    var urls = (0, _create2.default)(null);
    var result = input.replace(urlRegex, function (_url) {
        var url = _url;
        var nice = '';
        var suffix = '';

        if (url.match(/^javascript:/i)) {
            return url;
        }

        if (url.match(/^www\./i)) {
            url = 'http://' + url;
        }

        if (url.indexOf('(') === -1 && url[url.length - 1] === ')') {
            suffix += ')';
            url = url.substr(0, url.length - 1);
        }

        nice = url;

        if (nice.length > 100) {
            nice = nice.substr(0, 100) + '...';
        }

        var out = '<a target="_blank" href="' + url.replace(/"/g, '%22') + '">' + _lodash2.default.escape(nice) + '</a>';

        if (opts.addHandle) {
            var cssClass = opts.handleClass || '';
            var content = opts.handleContent || '';
            out += '<a data-url="' + _lodash2.default.escape(url) + '" class="' + cssClass + '">' + content + '</a>';
        }

        var urlId = '---url' + Math.random() * 1e+17 + '---';
        urls[urlId] = out;
        out = urlId;

        foundUrls.push(url);
        return out + suffix;
    });

    result = _lodash2.default.escape(result);
    (0, _keys2.default)(urls).forEach(function (urlId) {
        result = result.replace(urlId, urls[urlId]);
    });

    return {
        urls: foundUrls,
        html: result
    };
}

function addEmojis(wordCtx, emojiList, emojiLocation) {
    var word = '';
    var words = [word];

    if ((typeof wordCtx === 'undefined' ? 'undefined' : (0, _typeof3.default)(wordCtx)) === 'object') {
        word = wordCtx.word;
        words = wordCtx.words;
    } else {
        word = wordCtx;
    }

    if (emojiList.hasOwnProperty && !emojiList.hasOwnProperty(word)) {
        return word;
    }

    var emoji = emojiList[word];
    if (emoji) {
        var classes = 'kiwi-messagelist-emoji';
        if (_lodash2.default.compact(words).length === 1) {
            classes += ' kiwi-messagelist-emoji--single';
        }

        var src = '' + emojiLocation + emoji + '.png';
        return '<img class="' + classes + '" src="' + src + '" alt="' + word + '" title="' + word + '" />';
    }

    return word;
}

var channelMatch = /(^|\s)([@+~&%}]*)([#&][^ .,\007<>\n\r]+?)([:;.,<>\n\r]+)?$/i;
function linkifyChannels(word) {
    return word.replace(channelMatch, function (match, mLead, mPrefix, mChannel, mSuffix) {
        var chan = _lodash2.default.escape(mChannel.trim());
        var lead = _lodash2.default.escape(mLead);
        var prefix = _lodash2.default.escape(mPrefix);
        var suffix = _lodash2.default.escape(mSuffix);

        var link = '<a class="u-link kiwi-channel" data-channel-name="' + chan + '">' + chan + '</a>';
        return '' + lead + prefix + link + suffix;
    });
}

function linkifyUsers(word, userlist) {
    var ret = '';
    var user = null;
    var prepend = '';
    var append = '';
    var punc = ',.!:;-+)]?¿\\/<>@';
    var validLastChar = punc.indexOf(word[word.length - 1]) > -1;
    var normWord = word.toLowerCase();
    var hasProp = Object.prototype.hasOwnProperty;

    if (hasProp.call(userlist, normWord)) {
        user = userlist[normWord];
    } else if (hasProp.call(userlist, normWord.substr(0, normWord.length - 1)) && validLastChar) {
        user = userlist[normWord.substr(0, normWord.length - 1)];
        append = word[word.length - 1];
    } else if (hasProp.call(userlist, _lodash2.default.trim(normWord, punc))) {
        user = userlist[_lodash2.default.trim(normWord, punc)];
        var nickIdx = normWord.indexOf(user.nick.toLowerCase());
        append = word.substr(nickIdx + user.nick.length);
        prepend = word.substr(0, nickIdx);
    } else {
        return word;
    }

    var escaped = _lodash2.default.escape(user.nick);
    var colour = user.colour;

    ret = '<a class="kiwi-nick" data-nick="' + escaped + '"';
    if (colour) {
        ret += ' style="color:' + colour + '"';
    }
    ret += '>' + escaped + '</a>';

    if (prepend) {
        ret = _lodash2.default.escape(prepend) + ret;
    }
    if (append) {
        ret += _lodash2.default.escape(append);
    }

    return ret;
}

function createNickColour(nick) {
    var nickLower = nick.toLowerCase();

    var startingColour = '#36809B';

    var hash = (0, _Md.md5)(nickLower);
    var hueOffset = mapRange(hexVal(hash, 14, 3), 0, 4095, 0, 359);
    var satOffset = hexVal(hash, 17);
    var baseColour = Colours.rgb2hsl(Colours.hex2rgb(startingColour));
    baseColour.h = (baseColour.h * 360 - hueOffset + 360) % 360 / 360;

    if (satOffset % 2 === 0) {
        baseColour.s = Math.min(1, (baseColour.s * 100 + satOffset) / 100);
    } else {
        baseColour.s = Math.max(0, (baseColour.s * 100 - satOffset) / 100);
    }

    var themeMngr = _ThemeManager2.default.instance();
    var brightness = themeMngr.themeVar('nick-brightness');
    if (brightness) {
        baseColour.l = parseInt(brightness, 10) / 100;
    }

    var rgb = Colours.hsl2rgb(baseColour);
    var nickColour = Colours.rgb2hex(rgb);

    return nickColour;
}

function hexVal(hash, index, len) {
    return parseInt(hash.substr(index, len || 1), 16);
}

function mapRange(value, vMin, vMax, dMin, dMax) {
    var vValue = parseFloat(value);
    var vRange = vMax - vMin;
    var dRange = dMax - dMin;

    return (vValue - vMin) * dRange / vRange + dMin;
}

function formatAndT(formatId, formatParams, localeId, localeParams) {
    var body = t(localeId, localeParams);
    if (formatParams) {
        formatParams.text = body;
        body = formatText(formatId, formatParams);
    } else {
        body = formatText(formatId, { text: body });
    }

    return body;
}

function formatUser(fNick) {
    var nick = fNick;

    if ((typeof nick === 'undefined' ? 'undefined' : (0, _typeof3.default)(nick)) === 'object') {
        nick = nick.nick;
    }

    return formatText('user', { nick: nick });
}

function formatUserFull(fNick, fUsername, fHost) {
    var nick = '';
    var username = '';
    var host = '';

    if ((typeof fNick === 'undefined' ? 'undefined' : (0, _typeof3.default)(fNick)) === 'object') {
        var user = fNick;
        nick = user.nick;
        username = user.username || user.ident;
        host = user.hostname || user.host;
    } else {
        nick = fNick;
        username = fUsername;
        host = fHost;
    }

    return formatText('user_full', { nick: nick, username: username, host: host });
}

function formatText(formatId, formatParams) {
    var format = _state2.default.setting('textFormats.' + formatId);
    var params = formatParams;

    if (typeof params === 'string') {
        params = { text: params };
    }

    if (params.user) {
        params.nick = params.user.nick || '';
        params.username = params.user.username || '';
        params.host = params.user.hostname || '';
        params.prefix = params.user.prefix || '';
    }

    var result = format.replace(/%([A-Z]{2,})/ig, function (match, key) {
        var ret = '';
        if (typeof params[key] !== 'undefined') {
            ret = params[key];
        }

        return ret;
    });

    return result;
}

function enrichText(text, showEmoticons, emojiList, emojiLocation, userList) {
    var _this = this;

    var urls = [];
    var words = text.split(' ');
    words = words.map(function (word, wordIdx) {
        var parsed = void 0;

        var linkified = _this.linkifyUrls(word, {
            addHandle: true,
            handleClass: 'fa fa-chevron-right kiwi-messagelist-message-linkhandle'
        });
        if (linkified.urls.length > 0) {
            urls = urls.concat(linkified.urls);
            return linkified.html;
        }

        parsed = _this.linkifyChannels(word);
        if (parsed !== word) return parsed;

        if (userList) {
            parsed = _this.linkifyUsers(word, userList);
            if (parsed !== word) return parsed;
        }

        if (showEmoticons) {
            parsed = _this.addEmojis({ word: word, words: words, wordIdx: wordIdx }, emojiList, emojiLocation);
            if (parsed !== word) return parsed;
        }

        return _lodash2.default.escape(word);
    });

    return { html: words.join(' '), urls: urls };
}

function styleBlocksToHtml(blocks, showEmoticons, userList) {
    var _this2 = this;

    var urls = [];
    var html = '';
    var emojiList = _state2.default.setting('emojis');
    var emojiLocation = _state2.default.setting('emojiLocation');

    blocks.forEach(function (bl, idx) {
        var style = '';
        var classes = '';

        (0, _keys2.default)(bl.styles).forEach(function (s) {
            if (s === 'underline') {
                style += 'text-decoration:underline;';
            } else if (s === 'bold') {
                style += 'font-weight:bold;';
            } else if (s === 'italic') {
                style += 'font-style:italic;';
            } else if (s === 'quote') {
                classes += 'kiwi-formatting-extras-quote ';
            } else if (s === 'block') {
                classes += 'kiwi-formatting-extras-block ';
            } else if (s === 'color') {
                classes += 'irc-fg-colour-' + bl.styles[s] + ' ';
            } else if (s === 'background') {
                classes += 'irc-bg-colour-' + bl.styles[s] + ' ';
            }
        });

        var content = _this2.enrichText(bl.content, showEmoticons, emojiList, emojiLocation, userList);
        urls = urls.concat(content.urls);

        if (style === '' && classes === '') {
            html += content.html;
        } else if (style !== '' && classes !== '') {
            html += '<span style="' + style + '" class="' + classes + '">' + content.html + '</span>';
        } else if (style !== '') {
            html += '<span style="' + style + '">' + content.html + '</span>';
        } else if (classes !== '') {
            html += '<span class="' + classes + '">' + content.html + '</span>';
        }
    });
    return { html: html, urls: urls };
}

function formatDuration(timeSeconds) {
    var seconds = timeSeconds;

    var weeks = Math.floor(seconds / (3600 * 24 * 7));
    seconds -= weeks * 3600 * 24 * 7;

    var days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;

    var hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;

    var minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    var tmp = [];
    weeks && tmp.push(t('week', { count: weeks }));
    (weeks || days) && tmp.push(t('day', { count: days }));
    (days || hours) && tmp.push(t('hour', { count: hours }));
    (days || hours || minutes) && tmp.push(t('minute', { count: minutes }));
    tmp.push(t('second', { count: seconds }));

    return tmp.join(' ');
}

function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

function t(key, options) {
    var val = _i18next2.default.t(key, options);
    if (!val) {
        var opts = options || {};
        opts.lng = 'en-us';
        val = _i18next2.default.t(key, opts);
    }
    return val;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["helpers"]) window._kiwi_exports["helpers"] = {};
window._kiwi_exports["helpers"]["TextFormatting"]
window._kiwi_exports.helpers.TextFormatting = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/helpers/TextFormatting.js
// module id = 15gS
// module chunks = 1